import React from 'react'
import classnames from 'classnames/bind'
import { useTranslation } from 'next-i18next'

// Libs
import { useAppSelector } from '@/redux/hooks'

// Components

// Constans
import { NETWORK_STATUS_QUALITY_LABEL } from '@/constants/liveRoom'

// Styles
import styles from './style.module.scss'

// Lotties

type NetworkStatusProps = {
  className?: string
}

const cx = classnames.bind(styles)

const NetworkStatus = (props: NetworkStatusProps) => {
  const { className } = props

  const { t } = useTranslation()

  const socketData = useAppSelector((state) => state.socket)

  const { networkStatus } = socketData

  return (
    <div className={cx('network', className)}>
      <div className={cx('network-status')} data-status={networkStatus.quality}></div>
      <p className={cx('network-text')}>{t(NETWORK_STATUS_QUALITY_LABEL[networkStatus.quality as string])}</p>
    </div>
  )
}

export default NetworkStatus
